<template>
    <div class="formInput__wrapper">
        <label
            :for="fieldId"
            class="formCheckbox"
            :class="checkboxLarge ? 'formCheckbox--large' : null ">
            <span class="formCheckbox__inputWrapper">
                <input
                    :id="fieldId"
                    :ref="fieldId"
                    v-model="fieldChecked"
                    type="checkbox"
                    :name="fieldName"
                    :value="fieldValue"
                    class="formCheckbox__input"
                    :class="fieldClasses"
                    :required="fieldRequired"
                    :disabled="fieldDisabled"
                    :aria-invalid="`${ ariaInvalidStatus }`"
                    :aria-checked="fieldChecked ? fieldChecked : 'false'"
                    :data-gtm="dataGtm"
                    @change="handleChange" />
            </span>
            <span class="formCheckbox__labelText">
                <span
                    v-if="fieldLabel && !labelCustomId"
                    v-html="fieldLabel">
                </span>
                <span
                    v-else
                    v-html="labelCustomText">
                </span>
                <slot></slot>
                <span
                    v-if="fieldRequired === true"
                    class="formCheckbox__required">*
                    <span class="visually-hidden">
                        {{ trans('LABEL_TEXT_SR_REQUIRED') }}
                    </span>
                </span>
            </span>
        </label>
    </div>
</template>

<script>
    import Translator from 'tools/trans';
    import formBaseProps from 'mixins/formBaseMixin';
    import formInputProps from 'mixins/formInputMixin';

    export default {
        mixins: [formBaseProps, formInputProps],
        model: {
            prop: 'checked',
            event: 'change',
        },
        props: {
            checked: { type: Boolean, default: null },
            dataGtm: { type: String, default: null },
            labelCustomId: { type: String, default: null },
            checkboxLarge: { type: Boolean, default: null },
        },
        data() {
            return {
                fieldChecked: this.checked !== null ? this.checked : this.getCheckedStatus(this.field),
                labelCustomText: '',
            };
        },
        watch: {
            value(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.fieldChecked = newValue;
                }
            },
            checked(value) {
                this.fieldChecked = value;
            },
        },
        methods: {
            trans: Translator.trans,
            handleChange(event) {
                this.$emit('change', event.currentTarget.checked);
                this.$emit('input', event.currentTarget.checked);
            },
            getCheckedStatus(field) {
                if (field.attr && (field.attr.checked === true || field.attr.checked === 'checked')) {
                    return true;
                }

                return field.checked === true;
            },
        },
        created() {
            if (this.labelCustomId) {
                this.labelElement = document.getElementById(this.labelCustomId);
                if (this.labelElement) {
                    this.labelCustomText = this.labelElement.innerHTML;
                }
            }
        },
        mounted() {
            if (this.labelElement && this.labelElement.parentNode) {
                this.labelElement.parentNode.removeChild(this.labelElement);
            }
        },
    };
</script>
